import { AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { loginAsAdmin } from '../api/authApi';
import { LoginAsAdminResponse } from '../@types/Account';

type useLoginAsAdminParams = {
  accountId: string,
};

export const useLoginAsAdmin = (
  onSuccessCallback: (response: LoginAsAdminResponse) => void,
): UseMutationResult<LoginAsAdminResponse, AxiosError | null, useLoginAsAdminParams, unknown> => {
  return useMutation(({ accountId }) => {
    return loginAsAdmin(accountId);
  },
  {
    onSuccess: (response: LoginAsAdminResponse) => {
      onSuccessCallback(response);
    },
  },
  );
};
